









import { Component, Prop, Vue } from 'vue-property-decorator';

import * as _ from 'lodash';

@Component
export default class NumberKeyboard extends Vue {
    get numberList() {
        const selectedNumbers: string[] = this.$store.getters.getSelectedNumbers();
        return ['7', '8', '9', '4', '5', '6', '1', '2', '3', '0', '', '' ].map((n, i) => {
            return {
                index: i,
                value: n,
                isSelected: _.includes(selectedNumbers, n),
                x: 50 * (i % 3),
                y: 50 * (i - (i % 3)) / 3,
            };
        });
    }

    public onClickKey(num: string) {
        this.$store.dispatch('selectNumber', num);
    }
}
